import {faLock} from "@fortawesome/pro-solid-svg-icons/faLock";
import {CustomAxiosErrorType} from "@twigsby/client-data";
import {ContentBlock} from "@twigsby/frontend-framework";
import React from "react";

interface EndpointErrorType extends CustomAxiosErrorType {
    stacked?: boolean;
    extraClass?: string;
}

const EndpointError = (props: EndpointErrorType) => {
    if(props.response?.status === 403) {
        return (
            <ContentBlock
                error={true}
                iconContent={{ icon: faLock }}
                title={'403: Forbidden'}
                content={"Your don't have permission to access this resource"}
                stacked={props.stacked}
                extraClass={`text-center ${props.extraClass}`}
            />
        )
    }

    return (
        <ContentBlock
            error={true}
            title={props.errorRequestName}
            content={props.errorRequestMessage}
            stacked={props.stacked}
            extraClass={`text-center ${props.extraClass}`}
        />
    )
}

export { EndpointError }
